export default function () {
    return function (value, skipNullCheck) {
        if (!skipNullCheck && (value === undefined || value === null)) {
            return '';
        }

        return value ? 'Yes' : 'No';
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/filters/boolean.js